import { Modifier } from '@dnd-kit/core';
import { Transform } from '@dnd-kit/utilities/dist/css';

export const restrictVerticalDrift: Modifier = ({ transform }: { transform: Transform }) => ({
  ...transform,
  y: 0
});

export const restrictToScrollContainerBounds: Modifier = ({
  transform,
  draggingNodeRect,
  scrollableAncestors,
  scrollableAncestorRects
}) => {
  const container = scrollableAncestors[0];
  const containerRect = scrollableAncestorRects[0];
  if (!(container instanceof HTMLElement) || !draggingNodeRect || !containerRect) {
    return transform;
  }

  if (!draggingNodeRect || !container || !containerRect) {
    return transform;
  }

  const elementLeftInContainer = draggingNodeRect.left - containerRect.left + container.scrollLeft;
  const minX = -elementLeftInContainer;
  const maxX = container.scrollWidth - elementLeftInContainer - draggingNodeRect.width;

  return { ...transform, x: Math.min(Math.max(transform.x, minX), maxX) };
};
